import React, { useState, useEffect, useRef } from 'react';
import { FiPhone, FiClock, FiMapPin, FiMenu, FiX, FiChevronDown, FiChevronRight, FiArrowRight, FiPlay } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import './App.css';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activePilatesFaq, setActivePilatesFaq] = useState(null);
  const [activeManuelFaq, setActiveManuelFaq] = useState(null);
  const [activeTreatment, setActiveTreatment] = useState(null);
  const [showPilatesDetail, setShowPilatesDetail] = useState(false);
  const [activeGalleryFilter, setActiveGalleryFilter] = useState('all');
  const [lightboxImage, setLightboxImage] = useState(null);
  const [lightboxVideo, setLightboxVideo] = useState(null);
  const videoRefs = useRef({});

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  /* ========== DATA ========== */

  const pilatesFAQ = [
    {
      question: "Pilates Nedir?",
      answer: "Pilates, kontrollü hareketler, doğru duruş ve bilinçli nefes alma yoluyla kasları güçlendirmeye, esnekliği artırmaya ve genel vücut farkındalığını geliştirmeye odaklanan bir egzersiz türüdür. Mat üzerinde veya özel ekipman kullanılarak yapılabilir."
    },
    {
      question: "Pilatesin Faydaları Nelerdir?",
      answer: "Pilates, kasları kuvvetlendirme, duruşun iyileştirilmesi, esnekliğin artırılması, denge becerilerinin geliştirilmesi, yaralanma riskinin azalması ve rehabilitasyon ile ağrı yönetimine destek sağlama gibi birçok fayda sunar. Ayrıca bilinçli hareket pratiğini teşvik ederek genel zindelik ve vücut farkındalığını artırır. Fizyoterapist gözetiminde uygulandığında, hareketler güvenli ve kişiye özel şekilde uyarlanabilir, bu sayede hem rehabilitasyon süreci desteklenir hem de performans gelişimi sağlanır."
    },
    {
      question: "Pilates Kimler Yapabilir?",
      answer: "Pilates, her yaştan birey için uygundur. İster yeni başlayan olun, ister sporcu, ister bir sakatlıktan iyileşiyor olun ya da genel fitness ve sağlığınızı geliştirmek isteyin; Pilates, ihtiyaçlarınıza ve hedeflerinize göre fizyoterapist eşliğinde güvenle uyarlanabilir. Bu sayede hareketler hem güvenli hem etkili olur, kas kuvveti, esneklik ve genel vücut farkındalığı hedeflerinize ulaşmanıza yardımcı olur."
    },
    {
      question: "Pilatese Başlamak İçin Deneyime İhtiyacım Var Mı?",
      answer: "Pilatese başlamak için önceden herhangi bir deneyime gerek yoktur. Uzman Fizyoterapistlerimiz sizi temel bilgiler konusunda yönlendirecek ve kişi seviyenize ve hedeflerinize uygun bir program oluşturacaktır."
    },
    {
      question: "Pilates Seansında Neler Beklenir?",
      answer: "Pilates seansı sırasında, kontrollü hareketlere, doğru duruşa ve bilinçli nefes almaya odaklanan bir dizi egzersiz yapacaksınız. Seanslar, mat üzerinde yapılan çalışmaları veya reformer, cadillac ve sandalye gibi özel ekipmanlar üzerinde yapılan egzersizleri içerebilir. Fizyoterapistiniz size kişiselleştirilmiş rehberlik ve düzeltmeler sağlayacaktır."
    }
  ];

  const manuelTerapiFAQ = [
    {
      question: "Manuel Terapi Nedir?",
      answer: "Manuel terapi, alanında uzman Fizyoterapistlerin kas-iskelet sistemi ağrılarını ve işlev bozukluklarını teşhis ve tedavi etmek için ellerini kullandığı bir fizik tedavi türüdür. Teknikler arasında masaj, eklem mobilizasyonu ve manipülasyon yer alabilir."
    },
    {
      question: "Manuel Terapi Hangi Rahatsızlıkları Tedavi Edebilir?",
      answer: "Manuel terapi, bel ve boyun ağrısı, spor yaralanmaları, kas gerginliği, eklem disfonksiyonu ve kronik ağrı dahil olmak üzere çok çeşitli rahatsızlıkları tedavi edebilir. Ayrıca ameliyat sonrası iyileşmeye yardımcı olabilir ve genel hareket kabiliyetini artırabilir."
    },
    {
      question: "Manuel Terapi Nasıl Çalışır?",
      answer: "Manuel terapi, kas dokusuna basınç uygulayarak ve eklemleri manipüle ederek çalışır. Bu, ağrıyı azaltmaya, hareket açıklığını artırmaya, dolaşımı iyileştirmeye ve rahatlamayı ve iyileşmeyi desteklemeye yardımcı olabilir."
    },
    {
      question: "Manuel Terapi Güvenli Midir?",
      answer: "Evet, manuel terapi, eğitimli ve lisanslı bir Fizyoterapist tarafından uygulandığında güvenlidir. Fizyoterapistlerimiz, kullanılan tekniklerin hastaların durumuna ve sağlık durumuna uygun olduğundan emin olmak için her hastayı bireysel olarak değerlendirir özel testlemeler yapar ve kişiye uygun tedaviyi uygular."
    },
    {
      question: "Manuel Terapi Seansında Neler Beklenir?",
      answer: "Manuel terapi seansı sırasında terapist öncelikle durumunuzu değerlendirecektir. Ardından seans, sorunlarınıza yönelik masaj, mobilizasyon veya manipülasyon gibi uygulamalı teknikleri içerecektir."
    }
  ];

  const treatmentAreas = [
    {
      title: "Bel, Boyun ve Omuz Ağrıları",
      icon: "🦴",
      image: process.env.PUBLIC_URL + "/treatment-equipment.jpeg",
      intro: "Bel ve boyun ağrıları; genellikle kas gerginliği, duruş bozuklukları, fıtıklar veya eklem kısıtlılıklarından kaynaklanabilir. Omuz bölgesinde ise kas dengesizlikleri, hareket kısıtlılıkları veya eklem sorunları sık görülür.",
      details: [
        "Ağrının kaynağını değerlendirir ve kişiye özel plan hazırlar.",
        "Kas kuvvetlendirme ve esneklik egzersizleri uygular.",
        "Postür ve doğru hareket alışkanlıklarını öğretir.",
        "Manuel terapi ile kas ve eklem fonksiyonunu artırır.",
        "Reformer Pilates ve fonksiyonel egzersizlerle güvenli şekilde kas dengesini sağlar.",
        "Rehabilitasyon programıyla ağrıyı azaltır, hareket kabiliyetini geri kazandırır."
      ],
      footer: "Tüm uygulamalar uzman fizyoterapist eşliğinde yürütülür ve hedef, sadece ağrıyı azaltmak değil; kasları güçlendirmek, hareketi rahatlatmak ve yaşam kalitesini artırmaktır."
    },
    {
      title: "Kalça ve Diz Ağrıları",
      icon: "🦵",
      image: process.env.PUBLIC_URL + "/treatment-room-skeleton.jpeg",
      intro: "Kalça ve diz ağrıları, genellikle kas dengesizlikleri, eklem kısıtlılıkları, yıpranma, spor veya günlük aktivitelerden kaynaklanan zorlanmalar nedeniyle ortaya çıkar.",
      details: [
        "Ağrının kaynağını değerlendirir ve kişiye özel bir tedavi planı oluşturur.",
        "Kas kuvvetlendirme ve esneklik egzersizleri uygular.",
        "Eklem hareket açıklığını artırmak ve fonksiyonelliği sağlamak için manuel terapi teknikleri uygular.",
        "Duruş ve hareket alışkanlıklarını doğru şekilde kazandırır.",
        "Reformer Pilates ve fonksiyonel egzersizlerle kas dengesini destekler.",
        "Rehabilitasyon programı ile ağrıyı azaltır ve hareket kabiliyetini geri kazandırır."
      ],
      footer: "Tüm uygulamalar uzman fizyoterapist eşliğinde yürütülür ve hedefimiz, sadece ağrıyı azaltmak değil; kasları güçlendirmek, eklem fonksiyonunu artırmak ve yaşam kalitesini yükseltmektir."
    },
    {
      title: "Spor Yaralanmaları",
      icon: "⚽",
      image: process.env.PUBLIC_URL + "/pilates-studio-corner.jpeg",
      intro: "Spor yaralanmaları kas, eklem veya bağ dokularında hasara neden olabilir ve hareket kabiliyetini kısıtlayabilir. Uzman fizyoterapistimiz, yaralanmanın türünü değerlendirir ve kişiye özel bir tedavi planı oluşturur.",
      details: [
        "Kas ve eklem fonksiyonunu geri kazandırmak için egzersiz ve rehabilitasyon uygular.",
        "Ağrıyı azaltmak ve iyileşme sürecini hızlandırmak için manuel terapi teknikleri uygular.",
        "Performansı güvenli şekilde artırmak ve tekrar yaralanmayı önlemek için rehberlik eder."
      ],
      footer: "Tüm uygulamalar uzman fizyoterapist eşliğinde yapılır ve hedef, sağlıklı ve güvenli bir şekilde spora dönmeyi sağlamaktır."
    },
    {
      title: "Kas Spazmları ve Gerginlikler",
      icon: "💪",
      image: process.env.PUBLIC_URL + "/office-anatomical.jpeg",
      intro: "Kas spazmları ve gerginlikler, genellikle aşırı kullanım, duruş bozukluğu veya stres kaynaklı oluşur. Uzman fizyoterapistimiz, kasın durumunu değerlendirir ve kişiye özel tedavi uygular.",
      details: [
        "Manuel terapi ve esneme teknikleri ile kasları rahatlatır.",
        "Kas kuvvetlendirme ve denge egzersizleri ile tekrar spazm riskini azaltır.",
        "Günlük yaşam ve duruş önerileriyle uzun süreli rahatlık sağlar."
      ],
      footer: "Tüm uygulamalar uzman fizyoterapist eşliğinde yapılır ve hedef, kasları rahatlatmak, ağrıyı azaltmak ve hareket kabiliyetinizi artırmaktır."
    }
  ];

  return (
    <div className="App">
      {/* ==================== FLOATING WHATSAPP BUTTON ==================== */}
      <a
        href="https://wa.me/905437386526"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="WhatsApp ile iletişime geçin"
      >
        <FaWhatsapp />
        <span className="whatsapp-tooltip">Bize Yazın</span>
      </a>

      {/* ==================== NAVBAR ==================== */}
      <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="navbar-container">
          <div className="navbar-logo" onClick={() => scrollToSection('hero')}>
            <span className="logo-text">Koşuyolu</span>
            <span className="logo-subtitle">FİZİK TEDAVİ</span>
          </div>
          <div className={`navbar-links ${mobileMenuOpen ? 'active' : ''}`}>
            <button onClick={() => scrollToSection('hero')}>Ana Sayfa</button>
            <button onClick={() => scrollToSection('hakkimizda')}>Hakkımızda</button>
            <button onClick={() => scrollToSection('hizmetler')}>Hizmetler</button>
            <button onClick={() => scrollToSection('tedavi-alanlari')}>Tedavi Alanları</button>
            <button onClick={() => scrollToSection('galeri')}>Galeri</button>
            <button onClick={() => scrollToSection('iletisim')}>İletişim</button>
          </div>
          <a href="tel:05437386526" className="navbar-cta">Randevu Al</a>
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </nav>

      {/* ==================== HERO SECTION ==================== */}
      <section id="hero" className="hero" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/pilates-studio-neon.jpeg)` }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-badge">Fizyoterapi & Egzersiz</div>
          <h1 className="hero-title">
            Sağlığınız En Kıymetli
            <span className="hero-title-accent"> Hazineniz..</span>
          </h1>
          <p className="hero-description">
            Sağlık ve Hareket üzerine odaklanan meslek hizmet birimi
          </p>
          <div className="hero-buttons">
            <a href="https://wa.me/905437386526" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              <FaWhatsapp /> WhatsApp ile Ulaşın
            </a>
            <button onClick={() => scrollToSection('hizmetler')} className="btn btn-outline">
              Hizmetlerimiz <FiArrowRight />
            </button>
          </div>
        </div>
        <div className="hero-wave">
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path d="M0,60 C360,120 720,0 1080,60 C1260,90 1380,80 1440,60 L1440,120 L0,120 Z" fill="#ffffff" />
          </svg>
        </div>
      </section>

      {/* ==================== CONTACT BAR ==================== */}
      <section className="contact-bar">
        <div className="contact-bar-container">
          <a href="tel:05437386526" className="contact-card">
            <div className="contact-card-icon">
              <FiPhone />
            </div>
            <div className="contact-card-info">
              <span className="contact-card-title">0543 738 65 26</span>
              <span className="contact-card-label">Bizi Arayın</span>
            </div>
          </a>
          <div className="contact-card">
            <div className="contact-card-icon">
              <FiClock />
            </div>
            <div className="contact-card-info">
              <span className="contact-card-title">Pzt - Cmt</span>
              <span className="contact-card-label">09:00 / 21:00</span>
            </div>
          </div>
          <div className="contact-card">
            <div className="contact-card-icon">
              <FiMapPin />
            </div>
            <div className="contact-card-info">
              <span className="contact-card-title">Koşuyolu Cd. 40-42</span>
              <span className="contact-card-label">Kadıköy / İstanbul</span>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== WELCOME / ABOUT ==================== */}
      <section id="hakkimizda" className="welcome">
        <div className="welcome-container">
          <div className="welcome-image">
            <img
              src={process.env.PUBLIC_URL + "/lobby-reception.jpeg"}
              alt="AURA Movement & Rehabilitation Resepsiyon"
            />
            <div className="welcome-image-accent"></div>
          </div>
          <div className="welcome-content">
            <div className="section-label">Hakkımızda</div>
            <h2 className="section-title">
              Koşuyolu Fizik Tedaviye
              <span className="title-accent"> Hoş Geldiniz</span>
            </h2>
            <div className="welcome-services-tags">
              <span className="service-tag">Fizyoterapi</span>
              <span className="service-tag">Ortopedik Rehabilitasyon</span>
              <span className="service-tag">Klinik Pilates</span>
              <span className="service-tag">Pre-Post Operatif Fizik Tedavi</span>
              <span className="service-tag">Medikal Egzersiz</span>
            </div>
            <p className="welcome-text">
              Sağlığınız için buradayız; Fizyoterapi, Klinik Pilates ve Medikal egzersiz ile
              yaşamı daha rahat ve konforlu hale getirebiliriz.
            </p>
            <a href="https://wa.me/905437386526" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              <FaWhatsapp /> İletişime Geçin
            </a>
          </div>
        </div>
      </section>

      {/* ==================== SERVICES ==================== */}
      <section id="hizmetler" className="services">
        <div className="services-wave-top">
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path d="M0,60 C360,0 720,120 1080,60 C1260,30 1380,40 1440,60 L1440,0 L0,0 Z" fill="#ffffff" />
          </svg>
        </div>
        <div className="services-container">
          <div className="section-label light">Hizmetlerimiz</div>
          <h2 className="section-title light">
            Tedaviye Dayalı
            <span className="title-accent-light"> Hizmetler</span>
          </h2>
          <p className="services-subtitle">
            Uzman fizyoterapistlerimiz eşliğinde, size özel tedavi programları sunuyoruz.
          </p>

          <div className="services-grid">
            {/* Pilates Card */}
            <div className="service-card" onClick={() => setShowPilatesDetail(true)}>
              <div className="service-card-image">
                <img
                  src={process.env.PUBLIC_URL + "/pilates-reformers.jpeg"}
                  alt="Pilates Reformer"
                />
                <div className="service-card-overlay">
                  <span>Detayları Gör <FiArrowRight /></span>
                </div>
              </div>
              <div className="service-card-content">
                <h3>Pilates</h3>
                <p>Kasları güçlendirmeye, esnekliği artırmaya ve genel vücut farkındalığını geliştirmeye odaklanır.</p>
              </div>
            </div>

            {/* Manuel Terapi Card */}
            <div className="service-card" onClick={() => scrollToSection('manuel-terapi')}>
              <div className="service-card-image">
                <img
                  src={process.env.PUBLIC_URL + "/treatment-equipment.jpeg"}
                  alt="Manuel Terapi"
                />
                <div className="service-card-overlay">
                  <span>Detayları Gör <FiArrowRight /></span>
                </div>
              </div>
              <div className="service-card-content">
                <h3>Manuel Terapi</h3>
                <p>Kas-iskelet sistemi ağrılarını ve işlev bozukluklarını teşhis ve tedavi etmek için uygulanan özel teknikler.</p>
              </div>
            </div>

            {/* Fizyoterapi Card */}
            <div className="service-card">
              <div className="service-card-image">
                <img
                  src={process.env.PUBLIC_URL + "/office-anatomical.jpeg"}
                  alt="Fizyoterapi"
                />
                <div className="service-card-overlay">
                  <span>Yakında <FiArrowRight /></span>
                </div>
              </div>
              <div className="service-card-content">
                <h3>Fizyoterapi</h3>
                <p>Ağrı yönetimi ve fonksiyonel iyileşme için kanıta dayalı tedavi programları.</p>
              </div>
            </div>

            {/* Medikal Egzersiz Card */}
            <div className="service-card">
              <div className="service-card-image">
                <img
                  src={process.env.PUBLIC_URL + "/neon-sign-close.jpeg"}
                  alt="Medikal Egzersiz"
                />
                <div className="service-card-overlay">
                  <span>Yakında <FiArrowRight /></span>
                </div>
              </div>
              <div className="service-card-content">
                <h3>Medikal Egzersiz</h3>
                <p>Sağlık durumunuza uygun, kişiselleştirilmiş egzersiz programları.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="services-wave-bottom">
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path d="M0,60 C360,120 720,0 1080,60 C1260,90 1380,80 1440,60 L1440,120 L0,120 Z" fill="#ffffff" />
          </svg>
        </div>
      </section>

      {/* ==================== PILATES DETAIL MODAL ==================== */}
      {showPilatesDetail && (
        <div className="modal-overlay" onClick={() => setShowPilatesDetail(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowPilatesDetail(false)}>
              <FiX />
            </button>
            <div className="modal-hero">
              <img
                src={process.env.PUBLIC_URL + "/pilates-studio-full.jpeg"}
                alt="Pilates Stüdyosu"
              />
              <div className="modal-hero-overlay">
                <h2>Pilates</h2>
              </div>
            </div>
            <div className="modal-body">
              <div className="pilates-intro">
                <p>
                  Pilates, kasları güçlendirmeye, esnekliği artırmaya ve genel vücut farkındalığını
                  geliştirmeye odaklanır. Joseph Pilates tarafından geliştirilen bu egzersiz biçimi,
                  kontrollü hareketler, doğru duruş ve bilinçli nefes ile uygulanır ve rehabilitasyon,
                  atletik antrenman veya genel fitness için güvenle kullanılabilir.
                </p>
                <p>
                  Pilates hizmetlerimiz, her yaştan ve farklı fiziksel seviyelerden bireylere hitap
                  etmektedir. İster duruşunuzu iyileştirmek, ister güç kazanmak, ister bir sakatlıktan
                  iyileşmek veya atletik performansınızı artırmak istiyor olun, Reformer Pilates'i
                  sertifikalı uzman bir fizyoterapist eşliğinde kişiselleştirilmiş bir programla sunuyoruz.
                  Destekleyici ve motive edici bir ortamda, hem mat tabanlı hem de ekipman tabanlı
                  seanslarla güvenli ve etkili bir deneyim sağlıyoruz.
                </p>
              </div>
              <div className="pilates-faq">
                <h3>Sıkça Sorulan Sorular</h3>
                {pilatesFAQ.map((item, index) => (
                  <div
                    key={index}
                    className={`accordion-item ${activePilatesFaq === index ? 'active' : ''}`}
                  >
                    <button
                      className="accordion-header"
                      onClick={() => setActivePilatesFaq(activePilatesFaq === index ? null : index)}
                    >
                      <span>{item.question}</span>
                      <FiChevronDown className="accordion-icon" />
                    </button>
                    <div className="accordion-body">
                      <div className="accordion-body-inner">
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ==================== PILATES SECTION (ON PAGE) ==================== */}
      <section id="pilates" className="pilates-section">
        <div className="pilates-section-container">
          <div className="pilates-section-content">
            <div className="section-label">Klinik Pilates</div>
            <h2 className="section-title">
              Uzman Fizyoterapist Eşliğinde
              <span className="title-accent"> Pilates</span>
            </h2>
            <p className="pilates-section-text">
              Pilates, kasları güçlendirmeye, esnekliği artırmaya ve genel vücut farkındalığını
              geliştirmeye odaklanır. Kontrollü hareketler, doğru duruş ve bilinçli nefes ile
              uygulanır ve rehabilitasyon, atletik antrenman veya genel fitness için güvenle kullanılabilir.
            </p>
            <p className="pilates-section-text">
              Pilates hizmetlerimiz, her yaştan ve farklı fiziksel seviyelerden bireylere hitap
              etmektedir. İster duruşunuzu iyileştirmek, ister güç kazanmak, ister bir sakatlıktan
              iyileşmek veya atletik performansınızı artırmak istiyor olun, Reformer Pilates'i
              sertifikalı uzman bir fizyoterapist eşliğinde kişiselleştirilmiş bir programla sunuyoruz.
            </p>
          </div>
          <div className="pilates-section-image">
            <img
              src={process.env.PUBLIC_URL + "/pilates-neon-mirrors.jpeg"}
              alt="Pilates Stüdyosu - AURA"
            />
          </div>
        </div>
        <div className="faq-container">
          <h3 className="faq-title">Sıkça Sorulan Sorular</h3>
          <div className="faq-grid">
            {pilatesFAQ.map((item, index) => (
              <div
                key={index}
                className={`faq-item ${activePilatesFaq === index ? 'active' : ''}`}
              >
                <button
                  className="faq-header"
                  onClick={() => setActivePilatesFaq(activePilatesFaq === index ? null : index)}
                >
                  <span>{item.question}</span>
                  <FiChevronRight className="faq-icon" />
                </button>
                <div className="faq-body">
                  <div className="faq-body-inner">
                    <p>{item.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ==================== MANUEL TERAPİ SECTION ==================== */}
      <section id="manuel-terapi" className="manuel-terapi-section">
        <div className="manuel-terapi-wave-top">
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path d="M0,40 C480,120 960,0 1440,80 L1440,0 L0,0 Z" fill="#f7fafa" />
          </svg>
        </div>
        <div className="manuel-terapi-container">
          <div className="manuel-terapi-hero-row">
            <div className="manuel-terapi-image">
              <img
                src={process.env.PUBLIC_URL + "/treatment-room-skeleton.jpeg"}
                alt="Manuel Terapi Odası"
              />
            </div>
            <div className="manuel-terapi-content">
              <div className="section-label">Manuel Terapi</div>
              <h2 className="section-title">
                Manuel Terapi
                <span className="title-accent"> Hakkında</span>
              </h2>
              <p className="manuel-terapi-text">
                Manuel terapi, bir cihaz veya makine yerine ellerle uygulanan özel bir fizik tedavi
                şeklidir. Manuel terapide, uygulayıcılar kas spazmı, kas gerginliği ve eklem
                disfonksiyonundan kaynaklanan ağrıyı azaltmak için kas dokusuna baskı uygulamak ve
                eklemleri manipüle etmek için ellerini kullanırlar.
              </p>
              <p className="manuel-terapi-text">
                Bu uygulamalı yaklaşım, hareketliliği iyileştirmeye, rahatsızlığı hafifletmeye ve
                kas-iskelet sisteminin genel işlevini geliştirmeye yardımcı olur.
              </p>
            </div>
          </div>

          {/* Manuel Terapi FAQ */}
          <div className="faq-container manuel-terapi-faq">
            <h3 className="faq-title">Sıkça Sorulan Sorular</h3>
            <div className="faq-grid">
              {manuelTerapiFAQ.map((item, index) => (
                <div
                  key={index}
                  className={`faq-item ${activeManuelFaq === index ? 'active' : ''}`}
                >
                  <button
                    className="faq-header"
                    onClick={() => setActiveManuelFaq(activeManuelFaq === index ? null : index)}
                  >
                    <span>{item.question}</span>
                    <FiChevronRight className="faq-icon" />
                  </button>
                  <div className="faq-body">
                    <div className="faq-body-inner">
                      <p>{item.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ==================== TEDAVİ ALANLARI ==================== */}
      <section id="tedavi-alanlari" className="treatment-section">
        <div className="treatment-container">
          <div className="section-label">Tedavi Alanlarımız</div>
          <h2 className="section-title">
            Uzman Fizyoterapistimiz
            <span className="title-accent"> Neler Yapar?</span>
          </h2>
          <p className="treatment-subtitle">
            Ağrılarınızın kaynağını tespit eder, kişiye özel tedavi planı oluşturur ve uzman eşliğinde güvenle uygular.
          </p>

          <div className="treatment-grid">
            {treatmentAreas.map((area, index) => (
              <div
                key={index}
                className={`treatment-card ${activeTreatment === index ? 'expanded' : ''}`}
              >
                <div
                  className="treatment-card-header"
                  onClick={() => setActiveTreatment(activeTreatment === index ? null : index)}
                >
                  <div className="treatment-card-image">
                    <img src={area.image} alt={area.title} />
                    <div className="treatment-card-image-overlay"></div>
                  </div>
                  <div className="treatment-card-title-row">
                    <span className="treatment-card-emoji">{area.icon}</span>
                    <h3>{area.title}</h3>
                    <FiChevronDown className="treatment-card-arrow" />
                  </div>
                </div>
                <div className="treatment-card-body">
                  <div className="treatment-card-body-inner">
                    <p className="treatment-card-intro">{area.intro}</p>
                    <div className="treatment-card-subtitle">
                      <strong>Uzman fizyoterapistimiz neler yapar?</strong>
                    </div>
                    <ul className="treatment-card-list">
                      {area.details.map((detail, i) => (
                        <li key={i}>
                          <span className="treatment-check">✓</span>
                          {detail}
                        </li>
                      ))}
                    </ul>
                    <p className="treatment-card-footer">{area.footer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ==================== GALLERY SECTION ==================== */}
      <section id="galeri" className="gallery-section">
        <div className="gallery-container">
          <div className="section-label">Galeri</div>
          <h2 className="section-title">
            Merkezimizden
            <span className="title-accent"> Kareler</span>
          </h2>
          <p className="gallery-subtitle">
            AURA Movement & Rehabilitation merkezimizin modern ve konforlu ortamını keşfedin.
          </p>

          <div className="gallery-filters">
            {[
              { key: 'all', label: 'Tümü' },
              { key: 'studio', label: 'Pilates Stüdyosu' },
              { key: 'clinic', label: 'Klinik & Ofis' },
              { key: 'lobby', label: 'Resepsiyon & Lobi' },
              { key: 'video', label: 'Videolar' }
            ].map(f => (
              <button
                key={f.key}
                className={`gallery-filter-btn ${activeGalleryFilter === f.key ? 'active' : ''}`}
                onClick={() => setActiveGalleryFilter(f.key)}
              >
                {f.label}
              </button>
            ))}
          </div>

          {/* Videos First */}
          {(activeGalleryFilter === 'all' || activeGalleryFilter === 'video') && (
            <div className="gallery-videos-row">
              {[
                { src: "video-clinic-1.mp4", alt: "Klinik Tanıtım" },
                { src: "video-clinic-2.mp4", alt: "Klinik Tanıtım" },
                { src: "video-clinic-3.mp4", alt: "Klinik Tanıtım" },
                { src: "video-clinic-4.mp4", alt: "Klinik Tanıtım" },
                { src: "video-clinic-5.mp4", alt: "Klinik Tanıtım" },
                { src: "video-clinic-6.mp4", alt: "Klinik Tanıtım" },
              ].map((video, index) => (
                <div
                  key={`video-${index}`}
                  className="gallery-video-card"
                  onMouseEnter={() => {
                    const vid = videoRefs.current[`video-${index}`];
                    if (vid) vid.play().catch(() => {});
                  }}
                  onMouseLeave={() => {
                    const vid = videoRefs.current[`video-${index}`];
                    if (vid) { vid.pause(); vid.currentTime = 0; }
                  }}
                  onClick={() => setLightboxVideo(process.env.PUBLIC_URL + "/" + video.src)}
                >
                  <video
                    ref={el => videoRefs.current[`video-${index}`] = el}
                    src={process.env.PUBLIC_URL + "/" + video.src}
                    muted
                    loop
                    playsInline
                    preload="metadata"
                  />
                  <div className="gallery-video-play-icon">
                    <FiPlay />
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Photos Grid */}
          {activeGalleryFilter !== 'video' && (
            <div className="gallery-grid">
              {[
                { src: "pilates-reformers.jpeg", alt: "Pilates Reformer Makineleri", cat: "studio" },
                { src: "pilates-studio-full.jpeg", alt: "Pilates Stüdyosu", cat: "studio" },
                { src: "pilates-neon-mirrors.jpeg", alt: "Pilates Stüdyosu - Neon & Aynalar", cat: "studio" },
                { src: "pilates-studio-neon.jpeg", alt: "Pilates Stüdyosu Geniş Açı", cat: "studio" },
                { src: "pilates-studio-corner.jpeg", alt: "Pilates Stüdyosu Köşe", cat: "studio" },
                { src: "pilates-studio-plants.jpeg", alt: "Pilates Stüdyosu Bitkiler", cat: "studio" },
                { src: "office-anatomical.jpeg", alt: "Muayene Odası", cat: "clinic" },
                { src: "treatment-room-skeleton.jpeg", alt: "Tedavi Odası", cat: "clinic" },
                { src: "treatment-equipment.jpeg", alt: "Tedavi Ekipmanları", cat: "clinic" },
                { src: "lobby-reception.jpeg", alt: "Resepsiyon Alanı", cat: "lobby" },
                { src: "lobby-wide.jpeg", alt: "Lobi Geniş Görünüm", cat: "lobby" },
                { src: "lobby-tv-wall.jpeg", alt: "Lobi TV Duvarı", cat: "lobby" },
                { src: "reception-coffee.jpeg", alt: "Kahve Köşesi", cat: "lobby" },
                { src: "coffee-area.jpeg", alt: "AURA Kahve Alanı", cat: "lobby" },
                { src: "entrance-door.jpeg", alt: "AURA Giriş", cat: "lobby" },
                { src: "building-exterior.jpeg", alt: "Bina Dış Görünüm", cat: "lobby" },
                { src: "neon-sign-close.jpeg", alt: "All You Need Is Aura", cat: "lobby" },
              ]
                .filter(item => activeGalleryFilter === 'all' || item.cat === activeGalleryFilter)
                .map((item, index) => (
                  <div
                    key={index}
                    className="gallery-item"
                    onClick={() => setLightboxImage(process.env.PUBLIC_URL + "/" + item.src)}
                  >
                    <img
                      src={process.env.PUBLIC_URL + "/" + item.src}
                      alt={item.alt}
                      loading="lazy"
                    />
                    <div className="gallery-item-overlay">
                      <span>{item.alt}</span>
                    </div>
                  </div>
                ))
              }
            </div>
          )}
        </div>
      </section>

      {/* ==================== IMAGE LIGHTBOX ==================== */}
      {lightboxImage && (
        <div className="lightbox-overlay" onClick={() => setLightboxImage(null)}>
          <button className="lightbox-close" onClick={() => setLightboxImage(null)}>
            <FiX />
          </button>
          <img src={lightboxImage} alt="Galeri" onClick={(e) => e.stopPropagation()} />
        </div>
      )}

      {/* ==================== VIDEO LIGHTBOX ==================== */}
      {lightboxVideo && (
        <div className="lightbox-overlay" onClick={() => setLightboxVideo(null)}>
          <button className="lightbox-close" onClick={() => setLightboxVideo(null)}>
            <FiX />
          </button>
          <div className="lightbox-video-container" onClick={(e) => e.stopPropagation()}>
            <video
              src={lightboxVideo}
              controls
              autoPlay
              playsInline
              style={{ maxWidth: '100%', maxHeight: '85vh', borderRadius: '12px' }}
            />
          </div>
        </div>
      )}

      {/* ==================== MAP / CONTACT SECTION ==================== */}
      <section id="iletisim" className="contact-section">
        <div className="contact-section-wave-top">
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path d="M0,60 C360,0 720,120 1080,60 C1260,30 1380,40 1440,60 L1440,0 L0,0 Z" fill="#f7fafa" />
          </svg>
        </div>
        <div className="contact-section-container">
          <div className="contact-info-side">
            <div className="section-label">İletişim</div>
            <h2 className="section-title">
              Bize
              <span className="title-accent"> Ulaşın</span>
            </h2>
            <p className="contact-description">
              Sorularınız veya randevu talepleriniz için bize ulaşabilirsiniz.
            </p>
            <div className="contact-details">
              <div className="contact-detail-item">
                <FiPhone />
                <div>
                  <strong>Telefon</strong>
                  <a href="tel:05437386526">0543 738 65 26</a>
                </div>
              </div>
              <div className="contact-detail-item">
                <FaWhatsapp />
                <div>
                  <strong>WhatsApp</strong>
                  <a href="https://wa.me/905437386526" target="_blank" rel="noopener noreferrer">0543 738 65 26</a>
                </div>
              </div>
              <div className="contact-detail-item">
                <FiClock />
                <div>
                  <strong>Çalışma Saatleri</strong>
                  <span>Pazartesi - Cumartesi: 09:00 - 21:00</span>
                  <span>Pazar: Kapalı</span>
                </div>
              </div>
              <div className="contact-detail-item">
                <FiMapPin />
                <div>
                  <strong>Adres</strong>
                  <span>Koşuyolu Cd. 40-42, Kadıköy / İstanbul</span>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-map-side">
            <iframe
              title="Koşuyolu Fizik Tedavi Konum"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3012.5!2d29.028!3d40.987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac79e2ef0dedf%3A0x2c3b5c3e8c6d3e0a!2sKo%C5%9Fuyolu%20Cd.%2040-42%2C%20Kad%C4%B1k%C3%B6y%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1"
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: '16px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      {/* ==================== FOOTER ==================== */}
      <footer className="footer">
        <div className="footer-wave">
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path d="M0,60 C360,0 720,120 1080,60 C1260,30 1380,40 1440,60 L1440,0 L0,0 Z" fill="#ffffff" />
          </svg>
        </div>
        <div className="footer-container">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-text">Koşuyolu</span>
              <span className="logo-subtitle">FİZİK TEDAVİ</span>
            </div>
            <p className="footer-tagline">
              Sağlık ve Hareket üzerine odaklanan meslek hizmet birimi
            </p>
          </div>
          <div className="footer-links">
            <h4>Hızlı Bağlantılar</h4>
            <button onClick={() => scrollToSection('hero')}>Ana Sayfa</button>
            <button onClick={() => scrollToSection('hakkimizda')}>Hakkımızda</button>
            <button onClick={() => scrollToSection('hizmetler')}>Hizmetler</button>
            <button onClick={() => scrollToSection('tedavi-alanlari')}>Tedavi Alanları</button>
            <button onClick={() => scrollToSection('galeri')}>Galeri</button>
            <button onClick={() => scrollToSection('iletisim')}>İletişim</button>
          </div>
          <div className="footer-contact">
            <h4>İletişim</h4>
            <a href="tel:05437386526"><FiPhone /> 0543 738 65 26</a>
            <a href="https://wa.me/905437386526" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> WhatsApp</a>
            <span><FiClock /> Pzt - Cmt: 09:00 - 21:00</span>
            <span><FiMapPin /> Koşuyolu Cd. 40-42, Kadıköy / İstanbul</span>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Koşuyolu Fizik Tedavi. Tüm hakları saklıdır.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
